var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "black",
    viewBox: "0 0 14 14",
    className: "transition-colors duration-300 fill-white",
    width: 14,
    height: 14,
    "data-label": "svg.transition-colors",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.437 3.016-3.5-1.166h-.04a.408.408 0 0 0-.083 0h-.25L5.25 2.987 1.937 1.85a.583.583 0 0 0-.705.288.583.583 0 0 0-.065.266v8.166a.583.583 0 0 0 .397.555l3.5 1.166a.584.584 0 0 0 .361 0l3.325-1.108 3.314 1.137a.694.694 0 0 0 .186 0 .549.549 0 0 0 .339-.11.584.584 0 0 0 .245-.473V3.57a.584.584 0 0 0-.397-.554zm-7.77 7.91-2.333-.776V3.215l2.333.775v6.936zm3.5-.776-2.333.776V3.99l2.333-.775v6.935zm3.5.776-2.333-.776V3.215l2.333.775v6.936z",
    className: "st-current",
    "data-label": "path"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteboard);
export default __webpack_public_path__ + "static/media/whiteboard.09cf0caa31481beb85f25cdeb04ec488.svg";
export { ForwardRef as ReactComponent };